//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import { Globals } from '@axisnow/readium';
import Hammer from 'hammerjs';

var gesturesHandler = function(reader, viewport) {
  var onSwipeLeft = function() {
    reader.openPageRight();
  };

  var onSwipeRight = function() {
    reader.openPageLeft();
  };

  this.initialize = function() {
    reader.on(Globals.Events.CONTENT_DOCUMENT_LOADED, function(iframe, spineItem) {
      Globals.logEvent('CONTENT_DOCUMENT_LOADED', 'ON', 'gestures.js [ ' + spineItem.href + ' ]');
      var doc = iframe.contents()[0];

      bindGestures(doc);
    });

    var viewportId = viewport.replace('#', '');
    viewport = document.getElementById(viewportId);
    bindGestures(viewport);
  };

  function bindGestures(doc) {
    delete Hammer.defaults.cssProps.userSelect;
    delete Hammer.defaults.cssProps.touchSelect;

    var hammer = new Hammer.Manager(doc, {
      touchAction: 'auto',
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput,
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_HORIZONTAL
        }],
        [Hammer.Pan],
        [Hammer.Press]
      ]
    });

    var swipeConfig = {
      event: 'swipe',
      pointers: 1,
      threshold: 10,
      direction: Hammer.DIRECTION_HORIZONTAL,
      velocity: 0.3,
      prevent_mouseevents: true,
    };

    var Swipe = new Hammer.Swipe(swipeConfig);

    hammer.add(Swipe);

    hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    hammer.get('pan').set({ enable: false });
    hammer.get('press').set({ enable: false });

    hammer.on('swipeleft', function(event) {
      if (event.pointerType == 'touch') {
        window.swiped = true;
        onSwipeLeft();
      }
    });
    hammer.on('swiperight', function(event) {
      if (event.pointerType == 'touch') {
        window.swiped = true;
        onSwipeRight();
      }
    });
  }
};
export default gesturesHandler;
